import { Directive,  ViewContainerRef } from '@angular/core';
import { Supplier } from '../all-models';

@Directive({
  selector: '[pilotageEndelContainer]'
})
export class PilotageEndelContainerDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}

export class PilotageEndelContainerLoaderEvent {
 public container:PilotageEndelContainerDirective;
 public supplier:Supplier;
}
